import React from "react";
import Details from "../../Details/Details";

/*
 * PersonalDetailsStep — PostPurchaseSetup Step 2 (conditional).
 *
 * Renders the existing standalone <Details/> component (name + phone
 * + optional email + SMS opt-in) inside the wizard. Visibility is
 * controlled by the wizard shell — this step is only inserted into
 * the STEPS array when the Thankyou page passed `?personalDetails=true`
 * in the URL. If the user already has name + phone on the EndUser
 * record the form pre-populates from /auth/getUserDetails so they're
 * just confirming / editing.
 *
 * Wizard mode flips Details' post-save navigation: instead of routing
 * to /steps or /business-step (its standalone behaviour), Details
 * calls onWizardNext so the wizard advances to Step 3 (BusinessVerify).
 */
export default function PersonalDetailsStep({ onNext, onBack, onSkip, agentCtx }) {
  console.log(
    "[PersonalDetailsStep DEBUG] mounted — rendering Details with wizardMode=true",
  );
  return (
    <Details
      wizardMode={true}
      onWizardNext={onNext}
      onWizardSkip={onSkip}
    />
  );
}
